import ControlFactory from '@/Factories/ControlFactory';
import OverlayViewModel from '@/ViewModels/Controls/OverlayViewModel';
import Overlay from '@/Controls/Overlay';
import OverlayViewModelT from '@/ViewModels/Controls/OverlayViewModel';
import LabelViewModelT from '@/ViewModels/Controls/LabelViewModel';
import ImageViewModelT from '@/ViewModels/Controls/ImageViewModel';
import TextBoxViewModelT from '@/ViewModels/Controls/TextBoxViewModel';
import ButtonViewModelT from '@/ViewModels/Controls/ButtonViewModel';
import ComponentManager from '@/Management/ComponentManager';
import RADApplication from '@/Management/RADApplication';
import NavigationService from '@/Management/NavigationService';
import LabelT from '@/Controls/Label';
import ImageT from '@/Controls/Image';
import TextBoxT from '@/Controls/TextBox';
import ButtonT from '@/Controls/Button';
export default class FavoriteOverlayFactory extends ControlFactory {
    /** Overrides */
    public control: Overlay;
    /** Overrides */
    public viewModel: OverlayViewModel;
    public imageViewModel: any;
    public image: any;
    public headlineViewModel: any;
    public headline: any;
    public nameViewModel: any;
    public name: any;
    public listViewLabelViewModel: any;
    public textBoxViewModel: any;
    public textBox: any;
    public buttonAddViewModel: any;
    public buttonAdd: any;
    public buttonChangeViewModel: any;
    public buttonChange: any;
    public buttonRemoveViewModel: any;
    public buttonRemove: any;
    private OverlayViewModel: any;
    private Overlay: any;
    protected LabelViewModel: any;
    private favorites: any;
    private address: any;
    private isFavorite: any;
    private jQueryControl: JQuery;
    constructor(protected params: any) {
        super(params);
        this.jQueryControl = null;
        this.OverlayViewModel = ComponentManager.getViewModel<typeof OverlayViewModelT>('OverlayViewModel');
        this.Overlay = ComponentManager.getControl('Overlay');
        this.LabelViewModel = ComponentManager.getViewModel<typeof LabelViewModelT>('LabelViewModel');
        this.favorites = RADApplication.getInstance().user.getUserSpecificData('RAD_FAVOURITESITES', {});
        this.address = NavigationService.getInstance().getAddress().toString();
        this.isFavorite = this.defineComputed(() => {
            return this.address in this.favorites();
        });

        this.undisposeProperties.push('favorites');
    }
    /** Overrides */
    public getControl(): JQuery {
        if (this.jQueryControl != null) {
            return this.jQueryControl;
        }
        this.viewModel = (() => {
            return new this.OverlayViewModel({
                tooltip: new this.LabelViewModel({
                    ergName: this.detailViewItem.tooltip
                }),
                locator: this.locator,
                isVisible: true,
                isAutoHide: false,
                position: 'left',
                isShownOnClick: true,
                isShownOnHover: false,
                filter: '.extended .c-link',
                content: (() => {
                    let ImageViewModel = ComponentManager.getViewModel<typeof ImageViewModelT>('ImageViewModel');
                    let LabelViewModel = ComponentManager.getViewModel<typeof LabelViewModelT>('LabelViewModel');
                    let TextBoxViewModel = ComponentManager.getViewModel<typeof TextBoxViewModelT>('TextBoxViewModel');
                    let ButtonViewModel = ComponentManager.getViewModel<typeof ButtonViewModelT>('ButtonViewModel');
                    let Label = ComponentManager.getControl<typeof LabelT>('Label');
                    let Image = ComponentManager.getControl<typeof ImageT>('Image');
                    let TextBox = ComponentManager.getControl<typeof TextBoxT>('TextBox');
                    let Button = ComponentManager.getControl<typeof ButtonT>('Button');
                    let table = $('<table>');
                    let headerRow = $('<tr></tr>').appendTo(table);
                    let contentRow = $('<tr></tr>').appendTo(table);
                    let buttonRow = $('<tr></tr>').appendTo(table);
                    let imageCell = $('<td></td>').appendTo(headerRow);
                    let headlineCell = $('<td></td>').appendTo(headerRow);
                    let nameCell = $('<td></td>').appendTo(contentRow);
                    let inputCell = $('<td></td>').appendTo(contentRow);
                    let buttonCell = $('<td colspan="2"></td>').appendTo(buttonRow);
                    (() => {
                        this.imageViewModel = new ImageViewModel({
                            parentLocator: this.locator,
                            locator: 'image',
                            source: 'big_fav_icon.png',
                            alternativeText: new LabelViewModel({
                                ergName: 'FAVOURITE_TITLE'
                            })
                        });
                        this.image = new Image(this.imageViewModel);
                        let tuple = this.image.getTuple();
                        tuple.control.addClass('favorite-overlay-image');
                        tuple.control.appendTo(imageCell);
                    })();
                    (() => {
                        this.headlineViewModel = new LabelViewModel({
                            parentLocator: this.locator,
                            locator: 'title',
                            ergName: 'FAVOURITE_TITLE'
                        });
                        this.headline = new Label(this.headlineViewModel);
                        let tuple = this.headline.getTuple();
                        tuple.control.appendTo(headlineCell);
                    })();
                    (() => {
                        this.nameViewModel = new LabelViewModel({
                            parentLocator: this.locator,
                            locator: 'name-label',
                            ergName: 'FAVOURITE_NAME'
                        });
                        this.name = new Label(this.nameViewModel);
                        let tuple = this.name.getTuple();
                        tuple.control.appendTo(nameCell);
                    })();
                    (() => {
                        this.listViewLabelViewModel = new LabelViewModel({
                            ergName: this.params.ergName,
                            tryToLoad: false
                        });
                        this.textBoxViewModel = new TextBoxViewModel({
                            parentLocator: this.locator,
                            locator: 'name',
                            value: this.defineComputed(() => {
                                let favorites = RADApplication.getInstance().user.getUserSpecificData('RAD_FAVOURITESITES', {})();
                                let address = NavigationService.getInstance().getAddress().toString();
                                if (favorites != null && address in favorites) {
                                    return favorites[address];
                                }
                                else
                                    return '';
                            }),
                            maxLength: 120
                        });
                        this.textBox = new TextBox(this.textBoxViewModel);
                        let tuple = this.textBox.getTuple();
                        tuple.control.appendTo(inputCell);
                    })();
                    (() => {
                        this.buttonAddViewModel = new ButtonViewModel({
                            parentLocator: this.locator,
                            locator: 'add',
                            isVisible: this.defineComputed(() => {
                                return !this.isFavorite();
                            }),
                            label: new LabelViewModel({
                                parentLocator: this.locator,
                                locator: 'add.label',
                                ergName: 'FAVOURITE_ADD_TO'
                            }),
                            onClick: () => {
                                let name = this.textBoxViewModel.value();
                                this.addFavorite(this.address, name);
                                this.viewModel.isVisible(false);
                            }
                        });
                        this.buttonAdd = new Button(this.buttonAddViewModel);
                        let tuple = this.buttonAdd.getTuple();
                        tuple.control.appendTo(buttonCell);
                    })();
                    (() => {
                        this.buttonChangeViewModel = new ButtonViewModel({
                            parentLocator: this.locator,
                            locator: 'change',
                            isVisible: this.defineComputed(() => {
                                return this.isFavorite();
                            }),
                            label: new LabelViewModel({
                                parentLocator: this.locator,
                                locator: 'change.label',
                                ergName: 'FAVOURITE_CHANGE_TO'
                            }),
                            onClick: () => {
                                let name = this.textBoxViewModel.value();
                                this.addFavorite(this.address, name);
                                this.viewModel.isVisible(false);
                            }
                        });
                        this.buttonChange = new Button(this.buttonChangeViewModel);
                        let tuple = this.buttonChange.getTuple();
                        tuple.control.appendTo(buttonCell);
                    })();
                    (() => {
                        this.buttonRemoveViewModel = new ButtonViewModel({
                            parentLocator: this.locator,
                            locator: 'remove',
                            isVisible: this.defineComputed(() => {
                                return this.isFavorite();
                            }),
                            label: new LabelViewModel({
                                parentLocator: this.locator,
                                locator: 'remove.label',
                                ergName: 'FAVOURITE_REMOVE'
                            }),
                            onClick: () => {
                                this.removeFavorite(this.address);
                                this.viewModel.isVisible(false);
                            }
                        });
                        this.buttonRemove = new Button(this.buttonRemoveViewModel);
                        let tuple = this.buttonRemove.getTuple();
                        tuple.control.appendTo(buttonCell);
                    })();
                    return table;
                })()
            });
        })();
        this.control = (() => {
            return new this.Overlay(this.viewModel);
        })();
        let tuple = this.control.getTuple();
        this.jQueryControl = tuple.control;
        return this.jQueryControl;
    }
    public addFavorite(url: any, name: any): void {
        let fav = this.favorites();
        fav[url] = name;
        RADApplication.getInstance().user.setUserSpecificData('RAD_FAVOURITESITES', fav);
    }
    public removeFavorite(url: any): void {
        let fav = this.favorites();
        if (url in fav) {
            delete (fav[url]);
        }
        RADApplication.getInstance().user.setUserSpecificData('RAD_FAVOURITESITES', fav);
    }
}

ComponentManager.setFactory('FavoriteOverlay', FavoriteOverlayFactory, 'RADPresentation.HTMLClient.DefaultViewExtensions');